import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-barra-consulta-ajuda',
  templateUrl: './barra-consulta-ajuda.component.html',
  styleUrls: ['./barra-consulta-ajuda.component.css']
})

export class BarraConsultaAjudaComponent  implements OnInit {
 
  constructor() {
  }

  ngOnInit() {
  }

}
